import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface VimeoModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  vimeoId: string;
  vimeoHash: string;
}
export function VimeoModal({
  isOpen,
  onClose,
  title,
  vimeoId,
  vimeoHash
}: VimeoModalProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const previouslyFocused = useRef<HTMLElement | null>(null);
  useEffect(() => {
    if (!isOpen) return;
    previouslyFocused.current = document.activeElement as HTMLElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
      previouslyFocused.current?.focus();
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-185" data-mp="3bfx2d9gj410c">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-ink/95 p-4 backdrop-blur-md sm:p-10" role="dialog" aria-modal="true" aria-label={title} onMouseDown={event => {
      if (event.target === event.currentTarget) onClose();
    }} data-id="element-186" data-mp="3beufdcmbuipp">
          <button ref={closeButtonRef} type="button" onClick={onClose} className="absolute right-5 top-5 z-10 flex h-11 w-11 items-center justify-center rounded-full border border-led/30 bg-ink/60 text-led transition-colors duration-300 hover:border-ice focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice sm:right-8 sm:top-8" aria-label="Close" data-id="element-187" data-mp="3pen2yz2k4itg">
            <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-188" data-mp="2b88pnqy978fs" />
          </button>
          <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative aspect-video w-full max-w-5xl border border-led/20 shadow-[0_0_0_1px_rgba(242,247,255,0.1),0_0_60px_-10px_rgba(143,211,240,0.4)]" data-id="element-189" data-mp="2g58ophworaxe">
            <iframe title={title} src={`https://player.vimeo.com/video/${vimeoId}?h=${vimeoHash}&title=0&byline=0&portrait=0`} className="absolute inset-0 h-full w-full" frameBorder={0} referrerPolicy="strict-origin-when-cross-origin" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen data-id="element-190" data-mp="1wiaw0vhk1qj7" />
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}